<template>
<div class="main-container narrow">
  <div class="form main-container-item">
    <div class="form__container">
      <Logo />
      <template>
        <h2 class="title">Create Enklu Account</h2>
        <span class="form__line" v-if="errorText">
          <div class="form__error error">
            <div class="error__text" style="color: #EBA2A5; white-space: pre-wrap;">{{ errorText }}</div>
            <div class="error__btn" @click="errorText = false"></div>
          </div>
        </span>
        <div class="form__line">
          <label class="form__label" for="handle">Display Name</label>
          <div class="form__input_holder">
            <input
              class="form__input"
              id="handle"
              type="text"
              autocomplete="off"
              placeholder="Enter a display name"
              v-model="handle"
            />
          </div>
          <div class="note">This is what we’ll show to other users</div>
        </div>
        <div class="form__line">
          <label class="form__label" for="reg-email">Email</label>
          <div class="form__input_holder">
            <input
                class="form__input"
                id="ref-email"
                type="email"
                autocomplete="off"
                placeholder="Enter your email"
                v-model="email"
            />
          </div>
          <div class="note">Email will be used for login</div>
        </div>
        <div class="form__line">
          <label class="form__label" for="pass">Password</label>
          <div class="form__input_holder">
            <input
              class="form__input"
              id="pass"
              type="password"
              autocomplete="off"
              placeholder="Enter your password"
              v-model="password"
            />
          </div>
          <div class="note">Must be at least 6 characters</div>
        </div>
        <div class=".form__line">
          <div class="form__line_check">
            <input type="checkbox" name="agree" id="agree" v-model="agreedToEula"/>
            <label for="agree">I have read and agreed to <a href="/signup/pdf/terms.pdf" target="_blank"><u>Terms &amp; Conditions</u></a></label>
          </div>
        </div>  
        <button
          :disabled="!validRegistrationForm()"
          class="form__btn"
          type="button"
          @click.prevent="sendRegistration()"
        >SIGN UP</button>
        <div class="signin-link">
          <p>If you already have an Enklu account, 
            <a href="/#/signin" style="color: #33DED2"><u>please sign in here</u>.</a>
          </p>
        </div>
      </template>
    </div>
  </div>
</div>
</template>
<script>
import {
  changeRoute,
	validEmail
} from "@/js/util.js";
import Logo from "@/components/Logo.vue";

export default {
  name: 'Signup',
  components: { Logo },
  data() {
    return {
      email: '',
      password: '',
      handle: '',
      license: '',
      agreedToEula: false,
      errorText: '',
      loading: false,
      hasLicense: false,
      emailSubmitted: false,
      contactId: ''
    }
  },
  methods: {
    validEmailSubmission: function(){
        return validEmail(this.email)
    },
    submitEmail() {
      let fd = new FormData();
      fd.append("email", this.email);
      this.emailSubmitted = true;
      window.fbq('track', 'Lead', {content_name: "Signup"});
      this.$store.dispatch("createCRMContact",
      {
        data: { email: this.email },
        callback: ((contactId) => {
          this.contactId = contactId;
        }).bind(this)
      });
    },
    validPassword: password => password.length >= 6,
    validHandle: handle => handle.length > 0,
    validRegistrationForm: function(){
      const formIsValid = validEmail(this.email)
          && this.validPassword(this.password)
          && this.validHandle(this.handle)
          && this.agreedToEula;
      if (this.agreedToEula && !formIsValid) {
        let errCount = [this.validHandle(this.handle), validEmail(this.email), this.validPassword(this.password)];
        const handleErr = errCount[0] ? '' : ' Invalid display name: ' + this.handle + '.  ';
        const emailErr = errCount[1] ? '' : ' Invalid email: ' + this.email + '.  ';
        const passwordErr = errCount[2] ? '' : ' Invalid password: must be at least 6 characters.'

        this.errorText = errCount.length - errCount.filter(Boolean).length + ' form error(s) detected: ' + handleErr + emailErr + passwordErr;
      } else {
        this.errorText = ''
      }
      return formIsValid;
    },
    sendRegistration() {
      if (!this.agreedToEula) return;
      this.errorText = false;
      this.loading = true;

      // Send createCRMContact request separately from updateCRMRequest
      // HubSpot seems to have trouble with requests stepping over each other.
      this.submitEmail(); 

      let fd = new FormData();
      
      if (this.hasLicense) {
        fd.append('email', this.email);
        fd.append("password", this.password);
        fd.append("handle", this.handle);
        fd.append("license", this.license);
        fd.append("agreedToEula", true);
      } else {
        fd.append("email", this.email);
        fd.append("password", this.password);
        fd.append("handle", this.handle);
        // fd.append('license', this.license);
        fd.append("token", window.config.token);
        fd.append("plan", "");
        fd.append("agreedToEula", true);
      }
      this.$store.dispatch("sendSignupForm",
      {
        formData: fd,
        callback: (err) => {
          this.loading = false;
          if (err) {
            this.errorText = err;
          } else {
            // Force the CRM update to wait. HS can't seem to process requests too close together.
            // We also don't want to block Enklu account registration behind HubSpot request success.
            setTimeout(() => {
              this.dispatchCRMUpdate();
            }, 500);
            changeRoute(this, "/signup#done");
          }
        }
      });
    },
    dispatchCRMUpdate() {
      let hsContact = { contactId: this.contactId };
      this.$store.dispatch("updateCRMContact", { data: hsContact });
    },
  }
}
</script>